// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_R4ubi {
  max-width: 496px;
  height: 588px;
  display: flex;
  flex-direction: column;
}

.button_Sve48 {
  min-width: 128px;
}

.dialogHeader_O8TXI {
  padding: var(--size-pad12) var(--size-padLarge);
  border-bottom: 1px solid var(--color-base100);
}

.headerIcon_IFDb8 {
  width: 24px;
  height: 24px;
  background: var(--color-ScreenIconBackground); 
  color: var(--color-ScreenIcon); 
}
.headerIcon_IFDb8 > i {
  font-size: 10px;
}

.dialogBody_hCiUx {
  flex: 1;
  padding: var(--size-padLarge);
  background-color: var(--color-base050);
}
.dialogBody_hCiUx > * + * {
  margin-top: var(--size-padLarge);
}

.dialogFooter_tP1Uo {
  padding: var(--size-padLarge);
  border-top: 1px solid var(--color-base100);
}

.formLabel_JGTJ1 {
  margin-bottom: var(--size-padSmall);
}

/* Overriding default Toast's styling */
.toast_Qe8ZB {
  border-radius: var(--size-borderRadiusMedium) !important;
  min-height: 40px !important;
  padding: var(--size-padMedium) !important;
}
.toast_Qe8ZB > button {
  margin-top: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

.icon_Lt3pT {
  width: 24px;
  margin-left : 8px;
  margin-right : 8px;
}

.input_DPYTP {
  padding-left : 0px;
}

.selector_JEkUy {
  width: 100%;
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/ownershipTransfer/actions/completeAssetTransfer/SelectLocationClasses.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC","sourcesContent":[".dialog {\n  max-width: 496px;\n  height: 588px;\n  display: flex;\n  flex-direction: column;\n}\n\n.button {\n  min-width: 128px;\n}\n\n.dialogHeader {\n  padding: var(--size-pad12) var(--size-padLarge);\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.headerIcon {\n  width: 24px;\n  height: 24px;\n  background: var(--color-ScreenIconBackground); \n  color: var(--color-ScreenIcon); \n}\n.headerIcon > i {\n  font-size: 10px;\n}\n\n.dialogBody {\n  flex: 1;\n  padding: var(--size-padLarge);\n  background-color: var(--color-base050);\n}\n.dialogBody > * + * {\n  margin-top: var(--size-padLarge);\n}\n\n.dialogFooter {\n  padding: var(--size-padLarge);\n  border-top: 1px solid var(--color-base100);\n}\n\n.formLabel {\n  margin-bottom: var(--size-padSmall);\n}\n\n/* Overriding default Toast's styling */\n.toast {\n  border-radius: var(--size-borderRadiusMedium) !important;\n  min-height: 40px !important;\n  padding: var(--size-padMedium) !important;\n}\n.toast > button {\n  margin-top: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.icon {\n  width: 24px;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n.input {\n  padding-left : 0px;\n}\n\n.selector {\n  width: 100%;\n  background-color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_R4ubi`,
	"button": `button_Sve48`,
	"dialogHeader": `dialogHeader_O8TXI`,
	"headerIcon": `headerIcon_IFDb8`,
	"dialogBody": `dialogBody_hCiUx`,
	"dialogFooter": `dialogFooter_tP1Uo`,
	"formLabel": `formLabel_JGTJ1`,
	"toast": `toast_Qe8ZB`,
	"icon": `icon_Lt3pT`,
	"input": `input_DPYTP`,
	"selector": `selector_JEkUy`
};
export default ___CSS_LOADER_EXPORT___;
